/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据用户名或者电话或者用户id查询用户信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ByKeyParams {
  constructor(public key?: string) {}
}

export default async function (
  params: ByKeyParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.CuUser;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
